import { DiagnosticsLogState, DiagnosticsLogger } from '../store/schema/DiagnosticsLogState';
import { action } from 'satcheljs/lib/legacy';

// Map storing custom render methods for diagnostic panels that specify a custom render
export const customRenderPanelMap: {
    [name: string]: () => JSX.Element;
} = {};

export default action('registerDiagnostics')(function registerDiagnostics(
    logger: DiagnosticsLogger<any>,
    state: DiagnosticsLogState,
    onRenderContent?: () => JSX.Element // Specified for custom render diagnostics panels
) {
    if (logger.type == 'Custom' && !onRenderContent) {
        throw new Error('onRenderContent must be specified for custom DiagnosticsLogger type');
    }

    if (!logger.type) {
        logger.type = 'Default';
    }

    const loggerName = logger.name;
    state.loggers.set(loggerName, logger);

    if (onRenderContent) {
        customRenderPanelMap[loggerName] = onRenderContent;
    }
});
